import { TableBodyCell, UserAvatar } from '@pocketlaw/tetris';
export function EmailCell(props) {
    const { email } = props;
    return (<TableBodyCell headers="email">
      <UserAvatar size="sm" title={email}/>
    </TableBodyCell>);
}
